export enum SurveyStatusEnum {
    Active,
    InActive
}